
export default {
  name: 'Button',
}
